export default __webpack_public_path__ + "static/media/modalsearch.cd6e5855.svg";